<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("category", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("category", 2) }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div v-if="false">
        <router-link variant="default" class="btn-blue" to="add-category">{{
          $tc("add")
        }}</router-link>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            {{ $tc("category") }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("active") }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="Categories.length > 0">
        <tr v-for="(item, key) in Categories" :key="key">
          <td>{{ $tc(item.category_name, 1) }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="item.cat_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.cat_is_active == 'Y' ? 'active' : 'inactive'"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/mycinemas/edit-category', item)"
                  v-if="!(item.category_id == 1 || item.category_id == 2)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/mycinemas/view-category', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="Categories.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import MasterService from "@/services/MasterService";
import MyCinemaService from "@/services/MyCinemaService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      Cinemas: [],
      selectedCinema: undefined,
      cinema_id: null,

      gridView: false,
      listView: true,

      Categories: [],
      customErrors: {
        message: ""
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: ""
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.getCinemaList();
    this.getCategoryList();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCategoryList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    // onSelectCinema(cinema) {
    //     this.selectedCinema = cinema;
    //     this.cinema_id = cinema.cine_id;
    //     this.getCategoryList(this.cinema_id);
    // },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCategoryList();
      } else {
        this.currentPage = event;
        this.getCategoryList();
      }
    },
    /* eslint-disable */
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { category_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: category_id
        }
      });
    },

    getCinemaList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },

    getCategoryList: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        cinema_id: this.cinema_id
      };
      this.Categories = [];
      MyCinemaService.GetCategories(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Categories = data.Records;
              //   if (data.totalRows >= 10) {
              //     this.rows = data.totalRows;
              //   } else {
              //     this.rows = data.totalRows;
              //     this.selectedvalue = data.totalRows;
              //   }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MyCinemas/Category/ListCategory.vue